
import {
  defineComponent, shallowRef, onMounted, ref, watch,
} from 'vue';

import store from '@/store';

export default defineComponent({
  setup () {
    const dataType = ref([
      {
        icon: 'icon-area',
        color: 'red',
        des: '土地面积',
        data: 93718,
      },
      {
        icon: 'icon-green',
        color: 'blue',
        des: '绿地覆盖面积',
        data: 347252,
      },
      {
        icon: 'icon-forest',
        color: 'green',
        des: '森林面积',
        data: 298551,
      },
    ]);

    onMounted(() => {
      // console.log('onMounted');
    });

    return {
      dataType,
    };
  },
});
